import * as React from "react";
import useResizeObserver from "@react-hook/resize-observer";
// Define types for useSize hook
function useSize(target: HTMLElement | null): DOMRect | undefined {
    const [size, setSize] = React.useState<DOMRect>();

    React.useLayoutEffect(() => {
        if (target) {
            setSize(target.getBoundingClientRect());
        }
    }, [target]);

    useResizeObserver(target, (entry) => setSize(entry.contentRect));
    return size;
}

export default useSize;
